import { injector } from "@/services";
import { EErrorType, type ErrorService } from "draivn-ui-domain";
import { ROUTER_SERVICE_INJECTION_KEY } from "@/constants";
import { useSystemStore } from "../../store";
import { ROUTE_ERROR_SERVICE_UNAVAILABLE_NAME } from "../../../constants";

export const serverErrorDisplayHandlerInit = (errorService: ErrorService) => {
  const router = injector.injectFromRoot(ROUTER_SERVICE_INJECTION_KEY);
  const serverErrorDisplayHandler = () => {
    errorService.blockDisplay();
    const $systemStore = useSystemStore();
    $systemStore.setHealthStatus(false);

    if (
      router.currentRoute.value.name !== ROUTE_ERROR_SERVICE_UNAVAILABLE_NAME
    ) {
      void router.push({ name: ROUTE_ERROR_SERVICE_UNAVAILABLE_NAME });
    }
  };

  errorService.registerErrorDisplay(EErrorType.SERVER, {
    display: serverErrorDisplayHandler,
  });
};
